import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCalendar,
  FaClock,
} from "react-icons/fa";

const AppointmentSection = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    date: "",
    time: "",
    message: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Appointment form submitted:", formData);
    // Add form submission logic here (API call, validation, etc.)
  };

  return (
    <section className="relative pt-16 bg-no-repeat bg-cover bg-center" style={{ backgroundImage: "url('/assets/images/homepage/appointment_bg.jpg')" }}>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row gap-10">
          {/* Left Form */}
          <div className="w-full lg:w-1/2">
            <div className="bg-white shadow-lg rounded-lg">
              <h2 className="text-center text-3xl font-normal text-white bg-yellow-500  mb-6 p-8">
                {t('appointment.title')}
              </h2>
              <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4 p-8">
                {/* Name */}
                <div className="col-span-2 relative">
                  <input
                    name="name"
                    type="text"
                    placeholder={t('appointment.namePlaceholder')}
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border rounded-md pl-10"
                    required
                  />
                  <FaUser className="absolute left-3 top-3.5 text-gray-400" />
                </div>
                {/* Email */}
                <div className="col-span-2 relative">
                  <input
                    name="email"
                    type="email"
                    placeholder={t('appointment.emailPlaceholder')}
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border rounded-md pl-10"
                    required
                  />
                  <FaEnvelope className="absolute left-3 top-3.5 text-gray-400" />
                </div>
                {/* Phone */}
                <div className="col-span-2 relative">
                  <input
                    name="phone"
                    type="text"
                    placeholder={t('appointment.phonePlaceholder')}
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border rounded-md pl-10"
                    required
                  />
                  <FaPhone className="absolute left-3 top-3.5 text-gray-400" />
                </div>
                {/* Message */}
                <div className="col-span-2">
                  <textarea
                    name="message"
                    rows="4"
                    placeholder={t('appointment.messagePlaceholder')}
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border rounded-md"
                  ></textarea>
                </div>
                {/* Submit */}
                <div className="col-span-2 text-center">
                  <button
                    type="submit"
                    className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-[100px]"
                  >
                    {t('appointment.submit')}
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Right Image */}
          <div className="w-full lg:w-1/2 hidden lg:flex items-center justify-center">
            <img
              src="assets/images/homepage/appointment_person.png"
              alt={t('appointment.imageAlt')}
              className="max-w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentSection;
